type Props = {
  value: number;
  onChange: (n: number) => void;
  min?: number;
  step?: number;
  suffix?: string;
};

export default function NumberField({
  value,
  onChange,
  min = 0,
  step = 1,
  suffix,
}: Props) {
  return (
    <div className="row center gap-6">
      <input
        className="input right"
        type="number"
        min={min}
        step={step}
        value={value}
        onChange={(e) => {
          const n = parseFloat(e.target.value);
          onChange(Number.isFinite(n) ? Math.max(min, n) : min);
        }}
      />
      {suffix && <span className="muted">{suffix}</span>}
    </div>
  );
}
